import { render, staticRenderFns } from "./ContratoMenu.vue?vue&type=template&id=474d8ba7&scoped=true&"
import script from "./ContratoMenu.vue?vue&type=script&lang=js&"
export * from "./ContratoMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContratoMenu.vue?vue&type=style&index=0&id=474d8ba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474d8ba7",
  null
  
)

export default component.exports